import { QueryClient } from "@tanstack/react-query";

// Defaults are tuned to roughly match SWR's behavior so the migration from
// SWR keeps the same revalidation feel: a short stale window, refetch on
// window focus, and a single retry on transient errors.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
